import { render } from "./PurchaseReport.vue?vue&type=template&id=be017260&scoped=true"
import script from "./PurchaseReport.vue?vue&type=script&lang=js"
export * from "./PurchaseReport.vue?vue&type=script&lang=js"

import "./PurchaseReport.vue?vue&type=style&index=0&id=be017260&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be017260"]])

export default __exports__